// lista de acciones activas de un proyecto / dimension (alcance, crono, recurso)
import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "./index";
import { colores, bkCabGrilla, clCabGrilla, bkCeldaGrilla, clCeldaGrilla, sizeCelda, bkSeleccion, sizeCabezal, bbottomGrilla } from "./general"
import CRUDaccion from "./CRUDaccion";
import add from "./img/add.png";

export default function Acciones({ filtro }) {
  let { firebase } = useContext(AppContext);
  if (!filtro) filtro = "Todas";

  let color = colores["prioridad"];
  const [crudAccion, setCrudAccion] = useState(false);
  const [accion, setAccion] = useState(null);

  useEffect(() => {
    document.getElementById("htmlTituloPagS").innerHTML = "Acciones";
  }, []);

  return (
    <div style={SadmAcciones}>
      <div style={Sacciones}>
        <div style={Scabezal}><div>Acciones</div><div></div></div>
        <div style={SlistaAcciones}>
          {firebase.proyectoActivo &&
            firebase.acciones(firebase.proyectoActivo.proyecto.id, filtro, true).map((a) => (
              <div
                style={SdetalleAccion}
                key={a.id}
                onMouseEnter={(e) => (e.currentTarget.style.background = bkSeleccion)}
                onMouseLeave={(e) => (e.currentTarget.style.background = bkCeldaGrilla)}
                onClick={() => {
                  setAccion(a);
                  setCrudAccion(!crudAccion);
                }}
              >
                <div style={Scelda}>{a.descripcion.substr(0, 190)}</div>

                <div style={Scelda}>
                  <i className="material-icons icono20" style={{ color: `${color[a.prioridad]}` }}>
                    flag
              </i>
                </div>

              </div>
            ))}
        </div>
        <div style={Sadd}>
          <img
            src={add}
            alt="+"
            title="Agregar"
            height="25px"
            width="25px"
            style={{ display: "block", textAlign: "right", cursor: "pointer", marginTop: "10px" }}
            onClick={() => {
              setAccion(null);
              setCrudAccion(!crudAccion);
            }}
          ></img>
        </div>
      </div>
      <div style={Scrud}>
        {crudAccion && <CRUDaccion accion={accion} set={setCrudAccion} />}
      </div>
    </div >
  );
}
const SadmAcciones = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  width: "93.5vw",
  marginTop: "15px"
}

const Sacciones = {
  width: "53%",
}

const Scrud = {
  width: "38%",
}

const Scabezal = {
  display: "grid",
  gridTemplateColumns: " 95% 5%",
  background: bkCabGrilla,
  color: clCabGrilla,
  fontSize: sizeCabezal,
  fontWeight: 700,
  padding: "8px 0px 8px 3px",
};

const SlistaAcciones = {
  overflowY: "auto",
  maxHeight: "70vh",
  marginTop: "6px",
  cursor: "pointer"
};

const SdetalleAccion = {
  display: "grid",
  gridTemplateColumns: " 95% 5%",
  height: "6.8vh",
  marginBottom: "2px",
  background: bkCeldaGrilla,
  overflow: "hidden"
};

const Scelda = {
  borderBottom: bbottomGrilla,
  padding: "5px 2px 5px 2px",
  fontSize: sizeCelda,
  color: clCeldaGrilla
};

const Sadd = {
  display: "flex",
  justifyContent: "flex-start",
};

